import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import EcommerceOrderActions from '../../Redux/EcommerceOrderRedux'

class ViewShippingDetail extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editMode: false,
      showModal: null,
      detail: {},
      form: {
        note: '',
        status: ''
      }
    }
    this.status = [
      { value: 'ready-to-deliver', label: 'ready-to-deliver' },
      { value: 'deliver-to-courier', label: 'deliver-to-courier' },
      { value: 'delivered', label: 'delivered' },
      { value: 'reject-by-customer', label: 'reject-by-customer' },
      { value: 'missing', label: 'missing' }
    ]
  }

  componentDidMount = () => {
    this._customFetch()
  }

  _customFetch = () => {
    this.props.getEcommerceOrderShipping({ uuid: this.props.uuid })
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._customFetch()
    }
  }

  _editMode = (editMode) => {
    this.setState({ editMode })
    if (editMode) {
      this.setState({
        form: {
          note: this.state.detail.note,
          status: this.state.detail.status
        }
      })
    } else {
      this.setState({
        form: {
          note: '',
          status: ''
        }
      })
    }
  }

  _toggleForm = (item) => {
    this.setState({ detail: item })
    setTimeout(() => {
      this._editMode(true)
    }, 50)
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    setTimeout(() => {
      this._toggleModal(action)
    }, 50)
  }

  _inputChange = (event, field) => {
    event.preventDefault()
    let value = event.target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _delete = () => {
    let data = {
      uuid: this.state.detail.order_id,
      shippingUUID: this.state.detail.id
    }
    this.props.deleteEcommerceOrderShipping(data)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _submit = (event) => {
    event.preventDefault()
    this._editMode(false)
    if (this.state.editMode === false) {
      let form = { ...this.state.form }
      let uuid = this.props.uuid
      let data = {
        uuid,
        form
      }
      this.props.postEcommerceOrderShipping(data)
    } else {
      let form = { ...this.state.form }
      let data = {
        uuid: this.state.detail.order_id,
        shippingUUID: this.state.detail.id,
        form
      }
      this.props.putEcommerceOrderShipping(data)
    }
    setTimeout(() => {
      this._customFetch()
    }, 250)
  }

  _renderForm = (ORDER_NUMBER) => {
    return (
      <form onSubmit={(event) => this._submit(event)}>
        <div className='form-group row'>
          <div className='col-3'>
            <label className='control-label'>Order Number</label>
          </div>
          <div className='col-9'>
            <div className='form-control'>{ !this.state.editMode ? ORDER_NUMBER : `${ORDER_NUMBER} (EDIT)` }</div>
          </div>
        </div>
        <div className='form-group row'>
          <div className='col-3'>
            <label className='control-label'>Shipping Status</label>
          </div>
          <div className='col-9'>
            <select
              className='form-control'
              value={this.state.form.status}
              onChange={(event) => this._inputChange(event, 'status')}
            >
              <option disabled value=''>Choose shipping status</option>
              {
                this.status.map((item, i) => (
                  <option key={i} value={item.value}>{item.label}</option>
                ))
              }
            </select>
          </div>
        </div>
        <div className='form-group row'>
          <div className='col-3'>
            <label className='control-label'>Shipping notes</label>
          </div>
          <div className='col-9'>
            <textarea
              placeholder='Write shipping status here ...'
              rows='3'
              className='form-control'
              value={this.state.form.note}
              onChange={(event) => this._inputChange(event, 'note')}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-12 text-right'>
            {
              this.state.editMode
                ? <button className='btn btn-secondary mr-2' type='button' onClick={() => this._editMode(false)}>Cancel</button>
                : <button className='btn btn-secondary mr-2' type='button' onClick={() => this.props.closeModal()}>Close</button>
            }
            <button className='btn btn-primary' type='submit'>{ this.state.editMode ? 'Save' : 'Submit' }</button>
          </div>
        </div>
      </form>
    )
  }

  _renderTable = (ORDER_SHIPPING_HISTORIES) => {
    return (
      <table className='table table-hover table-striped'>
        <thead>
          <tr>
            <th className='text-center'>Status</th>
            <th className='text-center' style={{ minWidth: '250px' }}>Note</th>
            <th className='text-center'>Edit</th>
            <th className='text-center'>Delete</th>
          </tr>
        </thead>
        <tbody>
          {
            ORDER_SHIPPING_HISTORIES && ORDER_SHIPPING_HISTORIES.length > 0
              ? ORDER_SHIPPING_HISTORIES.map((item, i) => (
                <tr key={i}>
                  <td className='text-center'>{item.status}</td>
                  <td className='text-center'>{item.note}</td>
                  <td className='text-center'>
                    <button
                      className='btn btn-primary'
                      onClick={() => this._toggleForm(item)}
                      disabled={this.state.editMode}
                    >
                      <i className='fa fa-edit' />
                    </button>
                  </td>
                  <td className='text-center'>
                    <button
                      className='btn btn-danger'
                      onClick={() => this._selectItem(item, 'delete-shipping')}
                      disabled={this.state.editMode}
                    >
                      <i className='fa fa-trash' />
                    </button>
                  </td>
                </tr>
              ))
              : <tr>
                <td className='text-center' colSpan='4'>--No Data--</td>
              </tr>
          }
        </tbody>
      </table>
    )
  }

  _renderModal = () => {
    return (
      <Modal open={this.state.showModal === 'delete-shipping'} onClose={() => this.toggleModal()}>
        <section className='section'>
          <div className='title-block'>
            <h3 className='title'>Confirm Delete Shipping</h3>
          </div>
          <div className='row'>
            <div className='col-3'><p><strong>Status</strong></p></div>
            <div className='col-9'><p>{this.state.detail.status}</p></div>
          </div>
          <div className='row'>
            <div className='col-3'><p><strong>Note</strong></p></div>
            <div className='col-9'><p>{this.state.detail.note}</p></div>
          </div>
          <div className='mt-3 mb-3 text-right'>
            <button onClick={() => this._toggleModal()} className='btn btn-secondary mr-2' type='button'>Cancel</button>
            <button onClick={() => this._delete()} className='btn btn-danger'>Delete</button>
          </div>
        </section>
      </Modal>
    )
  }

  render () {
    const { DATA_DETAIL } = this.props
    return (
      <section className='section' style={{ width: '50vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Shipping Detail</h4>
        </div>
        <div>
          <section className='section'>{ this._renderForm(DATA_DETAIL.order_number) }</section>
          <section className='section'>{ this._renderTable(DATA_DETAIL.order_shipping_histories) }</section>
        </div>
        { this._renderModal() }
      </section>
    )
  }
}

const stateToProps = (state) => ({
  DATA_DETAIL: state.ecommerceOrder.DATA_DETAIL
})

const dispatchToProps = (dispatch) => ({
  getEcommerceOrderShipping: (data) => dispatch(EcommerceOrderActions.getEcommerceOrderShippingRequest(data)),
  postEcommerceOrderShipping: (data) => dispatch(EcommerceOrderActions.postEcommerceOrderShippingRequest(data)),
  putEcommerceOrderShipping: (data) => dispatch(EcommerceOrderActions.putEcommerceOrderShippingRequest(data)),
  deleteEcommerceOrderShipping: (data) => dispatch(EcommerceOrderActions.deleteEcommerceOrderShippingRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ViewShippingDetail)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/ViewShippingDetail.js